<template>
    <div class="c-benefits-slideshow">
        <y-slideshow
            ref="Slideshow"
            pagination="1"
            looped-slides="1"
            :other-options="slideshowOptions || options"
            data-aos="zoom-in"
            data-aos-duration="1000"
            height="auto"
            autoplay
            :class="{'remove-bullet-pagination': content.albums.length <= 3}"
        >
            <y-slide
                v-for="(album, index) in content.albums"
                :key="`responsive-benefits-${index}`"
            >
                <div class="c-benefits-slideshow__card">
                    <img
                        src="@/modules/api-market/assets/right-quote.svg"
                        :alt="album.title"
                        class="quote-img"
                        height="60"
                        width="60"
                    >

                    <div class="card-description">
                        <p>
                            {{ album.synopsis }}
                        </p>

                        <p v-if="expandText.includes(index)">
                            {{ album.custom.text }}
                        </p>
                        <span
                            v-if="!expandText.includes(index)"
                            class="learn-more"
                            @click="expandText.push(index)"
                        >
                            {{ $t('api-market.learn_more') }}
                        </span>
                    </div>
                    <div class="developer-more">
                        <div class="developer-info">
                            <div class="developer-info__avatar">
                                <img
                                    :src="imgSrc(album.image, 'main1')"
                                    :alt="album.title"
                                    class="developer-img"
                                >
                            </div>
                            <div class="developer-info__details">
                                <span class="developer-name">{{ album.title }}</span>
                                <span class="developer-company">{{ album.title2 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </y-slide>
        </y-slideshow>
    </div>
</template>

<script>
    import { YSlide, YSlideshow } from '@groot-components/all';

    export default {
        name      : 'Advantages',
        components: { YSlide, YSlideshow },
        props     : {
            content         : Object,
            slideshowOptions: Object,
        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                expandText: [],
                options   : {
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                            spaceBetween : 30,
                        },

                        0: {
                            slidesPerView: 1,
                            spaceBetween : 20,
                        },
                    },
                },

            };
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
